import angular from 'angular';
import cloneDeep from 'lodash/cloneDeep';

class InternalSashesService {
    constructor(config, windowDimensionsService) {
        this.config = config;
        this.windowDimensionsService = windowDimensionsService;
    }

    getNewIntSashId(parentSash) {
        let newIntSashId = 0;
        const sash = parentSash;
        if (sash.intSashes.length) {
            newIntSashId = sash.intSashes.slice(-1).pop().id + 1;
        }

        return newIntSashId;
    }

    createBottomPannelIntSash(parentSash) {
        const newIntSash = this.createNewIntSash(parentSash);
        const bottomPannel = {
            x: 0,
            y: this.windowDimensionsService.getBottomPannel(),
            filling: this.config.jsonConfig.bottomPannelFilling,
            width: parentSash.width,
            height: this.windowDimensionsService.height -
                this.windowDimensionsService.getBottomPannel()
        };

        return Object.assign(newIntSash, bottomPannel);
    }

    createNewIntSash(parentSash) {
        const newIntSash = {
            id: this.getNewIntSashId(parentSash),
            parentId: parentSash.id,
            nearDividers: cloneDeep(this.config.jsonConfig.nearDividers),
            muntins: cloneDeep(this.config.jsonConfig.muntins),
        };

        return Object.assign(newIntSash, this.config.jsonConfig.intSash);
    }
}

InternalSashesService.$inject = ['config', 'windowDimensionsService'];

export default angular.module('internalSashesService', [])
    .service('internalSashesService', InternalSashesService)
    .name;